import React from 'react';
import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import {ListItemText} from '@mui/material';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import {securedFetchRequest} from '@bidmii/common/lib/util/FetchRequest';
import {useRecoilValue} from 'recoil';
import makeStyles from '@mui/styles/makeStyles';
import {userState} from '../../../recoil/user/userAtom';
import {IUserResponse} from '@bidmii/common/lib/server/IServerApi';
import TertiaryButton from '../../../common/StyledComponents/TertiaryButton';
import useScreenWidth from '../../../common/useScreenWidth';

const useStyles = makeStyles((theme) => ({
  box: {
    height: 64,
    backgroundColor: theme.palette.gray.main,
    borderBottom: `2px solid ${theme.palette.gray.border}`,
    '& .MuiButton-root:hover': {
      backgroundColor: theme.palette.gray.main,
    },
  },
  listItemTextPrimary: {
    color: theme.palette.primary.main,
    fontFamily: 'AeonikProReqular',
    fontSize: '22px',
    paddingLeft: '15px',
  },
}));

function NotificationMenuHeader(props: $TSFixMe) {
  const classes = useStyles();
  const user = useRecoilValue(userState);
  const width = useScreenWidth();

  const handleReadAllNotification = () => {
    securedFetchRequest((user as IUserResponse)._links.notifications.href, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((res) => {
      if (res.status === 200) {
        const items = [...props.notifications];
        items.forEach((item) => {
          if (!item.hasBeenRead) {
            item.hasBeenRead = true;
          }
        });
        props.setNotifications(items);
      }
    });
  };

  const handleClearAllNotification = () => {
    securedFetchRequest((user as IUserResponse)._links.notifications.href, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((res) => {
      if (res.status === 200) {
        props.setNotifications([]);
      }
    });
  };

  return (
    <Box pt={0.5} className={classes.box}>
      <ListItem ContainerComponent="div" key={'notifications_container'}>
        <ListItemText classes={{primary: classes.listItemTextPrimary}}>
          Notifications
        </ListItemText>
        {props.notifications.length > 0 && (
          <ListItemSecondaryAction key={'clear_all'}>
            {props.notifications.find(
              (item: $TSFixMe) => item.hasBeenRead === false,
            ) ? (
              <TertiaryButton
                edge="end"
                aria-label="delete"
                onClick={handleReadAllNotification}>
                MARK ALL READ
              </TertiaryButton>
            ) : (
              <TertiaryButton
                edge="end"
                aria-label="delete"
                onClick={handleClearAllNotification}>
                CLEAR ALL
              </TertiaryButton>
            )}
            {width < 600 && (
              <TertiaryButton
                edge="end"
                aria-label="delete"
                onClick={props.closeDialog}
                style={{marginLeft: 15}}>
                CLOSE
              </TertiaryButton>
            )}
          </ListItemSecondaryAction>
        )}
        {props.notifications.length === 0 && width < 600 && (
          <ListItemSecondaryAction key={'close'}>
            <TertiaryButton
              edge="end"
              aria-label="delete"
              onClick={props.closeDialog}>
              CLOSE
            </TertiaryButton>
          </ListItemSecondaryAction>
        )}
      </ListItem>
    </Box>
  );
}

export default NotificationMenuHeader;
